(function($){
    $().ready(function () {
        let select = $('.book-good-deal>.select-container>.select-good-deal');
        let selectOptions = $('.book-good-deal>.select-container>.select-options')
        let hidingBg = $('.hiding-bg');

        select.on('click', (e) => {
            $(e.currentTarget).toggleClass('open')
            $(e.currentTarget).next().toggle();
            hidingBg.show();
        });

        hidingBg.on('click', (e) => {
            hidingBg.hide();
            $(select).removeClass('open')
            $(select).next().hide();
        })

        $(selectOptions).children('p').on('click', (e) => {
            let clickedEl = $(e.currentTarget);
            let url = clickedEl.data('value');
            let selectBar = clickedEl.parents('.select-options').prev();
            selectBar.html('<p><span>' + clickedEl.text() + '</span></p>');

            if (selectBar.children('p').data('value') === "") {
                selectOptions.children('p:first-of-type').toggleClass('not-visible')
            }

            if (url === "") {
                selectOptions.toggle();
                return
            }

            $(selectOptions).children('p').css('display', 'block')
            clickedEl.css('display', 'none');

            if ((typeof url === 'string' || url instanceof String)) {
                let win = window.open(url, '_blank');
                if (win) {
                    //Browser has allowed it to be opened
                    win.focus();
                } else {
                    //Browser has blocked it
                    alert('Please allow popups for this website');
                }
            }

            selectOptions.toggle();
        })
    });

})(jQuery);